import React from 'react';
import { Clock, ShieldCheck, TrendingDown, TrendingUp, Smile, Smartphone, Sparkles } from 'lucide-react';
import Navbar from '../../components/website/Navbar';
import Footer from '../../components/website/Footer';

const benefits = [
  { icon: Clock, title: 'Save time', desc: 'Cut monthly billing time from hours to minutes. Bulk operations for routes and vacations.' },
  { icon: ShieldCheck, title: 'Reduce mistakes', desc: 'No more quantity confusion, missed changes, or lost slips of paper.' },
  { icon: TrendingDown, title: 'Reduce wastage', desc: 'Prepare only what you need. See tomorrow\'s requirement in one click.' },
  { icon: TrendingUp, title: 'Collect faster', desc: 'Send reminders. See who owes what. Track cash, UPI, bank.' },
  { icon: Sparkles, title: 'Increase revenue', desc: 'Fewer errors + faster collections = healthier margins.' },
  { icon: Smile, title: 'Better trust', desc: 'Transparent bills, delivery history and vacation control build long-term relationships.' },
  { icon: Smartphone, title: 'Run from your phone', desc: 'Mobile-first. Works during morning delivery, at the store, or on the go.' },
];

export default function Benefits() {
  return (
    <div className="bg-rozops-bg min-h-screen">
      <Navbar />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-1.5 rounded-full bg-rozops-green-light text-rozops-green text-xs font-semibold px-3 py-1">Benefits</div>
          <h1 className="mt-4 font-heading font-extrabold text-4xl sm:text-5xl text-rozops-navy tracking-tight">Less work. Fewer mistakes. More business.</h1>
          <p className="mt-4 text-lg text-rozops-text-muted">RozOps helps merchants spend less time managing records and more time serving customers and growing revenue.</p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {benefits.map(({ icon: Icon, title, desc }) => (
            <div key={title} className="bg-white rounded-2xl border border-gray-100 shadow-soft p-6">
              <div className="w-11 h-11 rounded-xl bg-rozops-green-light text-rozops-green grid place-items-center mb-4">
                <Icon className="w-5 h-5" strokeWidth={2.2} />
              </div>
              <div className="font-heading font-bold text-lg text-rozops-navy">{title}</div>
              <p className="text-sm text-rozops-text-muted mt-1.5 leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>

        {/* Outcome */}
        <div className="mt-16 rounded-3xl bg-gradient-to-br from-rozops-navy via-rozops-accent to-rozops-blue p-10 text-white">
          <div className="grid md:grid-cols-4 gap-6 text-center">
            {[['3 hrs', 'saved per week'], ['+35%', 'faster collections'], ['−22%', 'less wastage'], ['0', 'missed changes']].map(([v, l]) => (
              <div key={v}>
                <div className="font-heading font-extrabold text-4xl tracking-tight">{v}</div>
                <div className="text-white/80 text-sm mt-1">{l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
